/**
 * AccentBarHeading — heading row with leading vertical gradient accent.
 */
import { Typography } from "../../atoms/Typography";
import { cn } from "@/utils/cn";
import type { AccentBarHeadingProps } from "./AccentBarHeading.types";
import { accentBarHeadingBarClass } from "./AccentBarHeading.styles";

export type { AccentBarHeadingProps } from "./AccentBarHeading.types";

export function AccentBarHeading({ children, className }: AccentBarHeadingProps) {
  return (
    <Typography
      variant="h4"
      weight="semibold"
      color="primary"
      className={cn("flex items-center gap-2", className)}
    >
      <span className={accentBarHeadingBarClass} aria-hidden />
      {children}
    </Typography>
  );
}
